<template>
  <page>
    <v-card>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="form.acctPeriod"
                  :label="labels.acctPeriod"
                  :error-messages="errors.collect('acctPeriod')"
                  :data-vv-as="labels.acctPeriod"
                  data-vv-name="acctPeriod"
                  append-icon="mdi-magnify"
                  @click:append="showAcctPeriodHelpList = true"
                  v-validate="'required'"
                  readonly
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-autocomplete
                  :label="labels.rptType"
                  :items="rptTypeList"
                  v-model="form.rptType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="rptType"
                  :data-vv-as="labels.rptType"
                  :error-messages="errors.collect('rptType')"
                  v-validate="'required'"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-flex xs12>
              <v-checkbox
                v-model="form.prtRptRunTime"
                :label="labels.prtRptRunTime"
                data-vv-name="prtRptRunTime"
                :data-vv-as="labels.prtRptRunTime"
              />
            </v-flex>
            <v-layout row wrap>
              <v-flex xs12 class="pt-3">
                <v-btn class="mr-2" color="info" :loading="submitting" @click.prevent="doSchedule">
                  <v-icon left dark>mdi-clock</v-icon>
                  {{ labels.schedule }}
                </v-btn>
                <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{ labels.export }}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="form.format">
                  <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{ format.label }}</span>
                    <v-icon :color="format.color">{{ format.icon }}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showAcctPeriodHelpList" width="1280px">
      <acct-period-help-list2
        @close="showAcctPeriodHelpList = false"
        @assign-acct-period-info="doAssign($event)"
        :boolRefresh="showAcctPeriodHelpList"
        :modeNo="modeNo"
      ></acct-period-help-list2>
    </v-dialog>

    <v-dialog v-model="scheduleJobModal" width="1000px" persistent>
      <ScheduleJob @close="scheduleJobModal = false" :jobName="jobName" :jobDesc="jobDesc"></ScheduleJob>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import ScheduleJob from '@/components/core/common/dialog/ScheduleJob'
import AcctPeriodHelpList2 from '@/components/core/common/dialog/AcctPeriodHelpList2'

export default {
  data() {
    return {
      labels: {
        acctPeriod: 'For Accounting Period',
        rptType: 'Report Type',
        prtRptRunTime: 'Print Run-time Parameters',
        format: 'Export Format',
        export: 'Export to',
        schedule: 'Schedule'
      },
      form: {
        acctPeriod: null,
        rptType: 'B',
        prtRptRunTime: false,
        format: 'PDF'
      },
      menu: {},
      supportedFormat: [],
      submitting: false,
      rptTypeList: [
        { code: 'B', value: 'Both' },
        { code: 'D', value: 'Detail' },
        { code: 'S', value: 'Summary' }
      ],
      mode: '',
      showAcctPeriodHelpList: false,
      modeNo: '3',
      today: new Date(),
      scheduleJobModal: false,
      jobName: 'qrtzGlPostChecklist',
      jobDesc: 'GL Posting Checklist'
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.glPostChecklist
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
            this.getAcctPer()
          }
        }
      } catch (err) {
        throw err
      }
    },
    async doAssign(data) {
      this.form.acctPeriod = data.acctPerMth + '/' + data.acctPerYr
    },
    doSchedule() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.scheduleJob()
        }
      })
    },
    scheduleJob() {
      this.scheduleJobModal = true
    },
    async getAcctPer() {
      const apiURI = this.menu.getAcctPer
      if (apiURI) {
        this.submitting = true
        try {
          const expand = { perEndDate: this.today }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            if (data.errMsg === '0' || data.errMsg === '' || data.errMsg === undefined) {
              this.form.acctPeriod = data.acctMth + '/' + data.acctYr
            } else {
              this.form.acctPeriod = null
              this.message(data)
              this.fieldMessage(data)
            }
            this.errdPerEnd = false
            this.errdPerEndMsg = ''
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportGlPostChecklist
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin],
  components: {
    ScheduleJob,
    AcctPeriodHelpList2
  }
}
</script>
